import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class ScrollControl {

  private scrollControl$: Subject<string>;

  constructor() {
    this.scrollControl$ = new Subject();
  }

  setScrollControl(selectors: string) {
    this.scrollControl$.next(selectors);
  }

  getScrollControl(): Observable<string> {
    return this.scrollControl$.asObservable();
  }
}
